import apiClient from '../../../services/api';

const memberService = {
    getMembers: async (hostAccountId) => {
        const response = await apiClient.get(`/members/${hostAccountId}`);
        return response.data.data;
    },

    getMemberStats: async (hostAccountId) => {
        const response = await apiClient.get(`/members/${hostAccountId}/stats`);
        return response.data.data;
    },

    syncMembers: async (hostAccountId) => {
        const response = await apiClient.post(`/members/${hostAccountId}/sync`);
        return response.data;
    },

    inviteMembers: async (hostAccountId, emails) => {
        // emails: string[]
        const response = await apiClient.post(`/members/${hostAccountId}/invite`, { emails });
        return response.data;
    },

    removeMember: async (hostAccountId, email) => {
        const response = await apiClient.delete(`/members/${hostAccountId}/remove`, {
            data: { email }
        });
        return response.data;
    },

    updateMemberRole: async (hostAccountId, email, role) => {
        const response = await apiClient.patch(`/members/${hostAccountId}/role`, {
            email,
            role
        });
        return response.data;
    },


};

export default memberService;
